import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import InputValueProps from '../../../../../prop-types/input-value-props';
import sharedStyles from '../../../../../../automation-rules/style.module.less';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import TextAreaWithInsertParameter from '../../../../../../../../components/text-area-with-insert-parameter';
import AlertParameterInsertOptions from './alert-parameter-insert-options';
import { INT_PARAMETER, PARAMETER } from '../../../../../constants/parameter-name-for-update';
import messages from './messages';
import style from './style.module.less';
import classnames from 'classnames';

const daysToExpireOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const CreateAlert = ({ inputValueProps, onChange, label }) => {
  const { [PARAMETER]: parameter, [INT_PARAMETER]: intParameter } = inputValueProps;
  const expireInDaysCount = intParameter || 1;
  const setActionValue = useCallback(
    (content) => {
      onChange({
        [PARAMETER]: content,
        [INT_PARAMETER]: expireInDaysCount,
      });
    },
    [onChange, expireInDaysCount],
  );

  const setExpireInDaysCount = useCallback(
    (selectedExpire) => {
      onChange({
        [PARAMETER]: parameter,
        [INT_PARAMETER]: selectedExpire,
      });
    },
    [onChange, parameter],
  );

  return (
    <div className={style['create-alert']}>
      <div className={style['multi-control-row']}>
        <div>{label}</div>
        <TextAreaWithInsertParameter onChange={setActionValue} parameterOptions={AlertParameterInsertOptions} value={parameter} />
      </div>
      <div className={classnames(style.stacked, style['multi-control-row'])}>
        <div>
          <FormattedMessage {...messages.createAlertsExpiration} />
        </div>
        <div>
          <DropdownMenu className={sharedStyles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
            <DropdownMenuToggler className={sharedStyles['dropdown-toggler']}>
              <FormattedMessage {...messages.createAlertsExpireInDays} values={{ daysCount: expireInDaysCount }} />
            </DropdownMenuToggler>
            {daysToExpireOptions.map((daysCount) => {
              return (
                <DropdownMenuItem
                  key={daysCount}
                  className={sharedStyles['dropdown-item']}
                  onClick={() => setExpireInDaysCount(daysCount)} // TODO: remove anon when dropdown supports typing for a further nested element
                  theme='unstyled'
                >
                  <div>
                    <FormattedMessage {...messages.createAlertsExpireInDays} values={{ daysCount }} />
                  </div>
                </DropdownMenuItem>
              );
            })}
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

CreateAlert.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default CreateAlert;
